import React from "react";
import PropTypes from "prop-types";

import "../assets/styles/Card.scss";

const CardAdd = (props) => {
  const { onClick } = props;
  return (
    <div className="l-card e-card e-card-fluid e-clickable" onClick={onClick ? onClick : () => {}}>
      <div className="e-card__content e-card__content-empty">
        <e-icon icon="plus" size="middle"></e-icon>
      </div>
      <div className="e-card__lead">
        <div className="e-card__caption">
          <div className="e-card__title">{props.addText}</div>
        </div>
      </div>
    </div>
  );
};

CardAdd.propTypes = {
  addText: PropTypes.string,
  onClick: PropTypes.func
};

export default CardAdd;
